<script setup lang="ts">
import { useUserData } from '~/composables/account/use-user-data'
import { useModal } from '~/composables/common/use-modal'
import { AccountTabs } from '~/constants/account'
import { ModalCollection } from '~/constants'

const { currentUser, currentBalanceFormat, avatar } = useUserData()
const { MAIN_CREDIT_UNIT } = useRuntimeConfig().public
const { closeModal } = useModal()
</script>

<template>
  <div class="user-info">
    <div class="user-info__user">
      <img class="user-info__avatar" :src="avatar" alt="avatar" />
      <div class="user-info__user__content">
        <div class="user-info__name line-limit-1">{{ currentUser.fullname }}</div>
        <div class="user-info__wallet">Ví chính <strong>{{ currentBalanceFormat }} {{ MAIN_CREDIT_UNIT }}</strong></div>
      </div>
    </div>
    <NuxtLink class="user-info__edit" :to="AccountTabs.INFORMATION" @click="closeModal(ModalCollection.MOBILE_MENU)">
      <img src="/assets/images/icons/pencil.svg" alt="edit" />Chỉnh&nbsp;sửa
    </NuxtLink>
  </div>
</template>

<style lang="scss" scoped>
.user-info {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__user {
    display: flex;
    align-items: center;
    gap: 12px;

    &__content {
      line-height: 24px;
    }
  }

  &__avatar {
    width: 56px;
    height: 56px;
    border-radius: 4px;
    filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.16));
  }

  &__name {
    color: $white;
    font-size: 20px;
    font-weight: $font-weight-bold;
    max-width: 130px;
  }

  &__wallet {
    margin-top: 4px;
    color: $primary-75;

    strong {
      color: #ffd451;
    }
  }

  &__edit {
    display: flex;
    gap: 4px;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    color: $white;
    background-color: rgba(255, 255, 255, 0.2);
  }
}
</style>
